import { atom } from 'recoil'
import { IProjectCheckpoint } from './projectCheckpoints.types'

interface ICheckpointsAtom {
  items: IProjectCheckpoint[]
}

const allCheckpointsAtom = atom<ICheckpointsAtom>({
  key: 'project-checkpoints',
  default: { items: [] },
})
export default allCheckpointsAtom
